import React, { createContext, useContext, useEffect, useState } from "react";
import { PUBLIC_MODE } from "../../constants/generalConstants";

const TSDataContext = createContext();

export const TSDataProvider = ({ children }) => {
  //mode is public and messaging

  const isMobile =  window.innerWidth < 768;
  const isMidium = window.innerWidth < 1200 && window.innerWidth >= 768;
  const [appData, setAppData] = useState({
    user: null,
    theme: "light",
    language: "fr",
  });
  const [mode, setMode] = useState(PUBLIC_MODE);
  const [isLoading, setIsLoading] = useState(false);
  const [messageActuel, setMessageActuel] = useState(null);
  const [openHistoriqueDialog, setOpenHistoriqueDialog] = useState(false);

  const updateAppData = (key, value) => {
    setAppData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  return (
    <TSDataContext.Provider
      value={{
        isLoading,
        setIsLoading,
        isMobile,
        isMidium,
        appData,
        mode,
        setMode,
        messageActuel,
        setMessageActuel,
        updateAppData,
        openHistoriqueDialog, 
        setOpenHistoriqueDialog
      }}
    >
      {children}
    </TSDataContext.Provider>
  );
};

// Custom hook for using the context
export const useTSData = () => {
  return useContext(TSDataContext);
};
